// Front/src/pages/Login.js

import { useState, useEffect } from "react";
import { useLogin } from "../hooks/useLogin";
import "../style/LoginandSignup.css";
import { Helmet } from "react-helmet-async";
import { useNavigate } from "react-router-dom";
import { useTranslate } from '../hooks/useTranslate';
import { useLanguageContext } from '../context/LanguageContext';


const Login = () => {
  // renamed state from "email" to "id" for clarity
  const [id, setId] = useState("");
  const [password, setPassword] = useState("");
  const { login, error, isLoading } = useLogin();
  const [loadingMessage, setLoadingMessage] = useState(""); // State for loading message
  const navigate = useNavigate();

  const { language } = useLanguageContext();
  const t = useTranslate();

  // This will always clear any stored user data when Login page loads
  useEffect(() => {
    localStorage.removeItem('user');
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoadingMessage(t.loginWait); // Set message when login starts
    const success = await login(id, password);

    if (success) {
      navigate("/mytasks");
    }

    setLoadingMessage(""); // Clear message when login completes

  };

  return (
    <div dir={language === 'he' ? 'rtl' : 'ltr'}>
      {/* Helmet to set the page title */}
      <Helmet>
        <title>Shekel Technet - Login</title>
      </Helmet>

      <form className="login" onSubmit={handleSubmit}>
        <h3>{t.login}</h3>

        <label>{t.id}</label>
        <input
          type="text"
          onChange={(e) => setId(e.target.value)}
          value={id}
          className="numeric-input"
        />

        <label>{t.password}</label>
        <input
          type="password"
          onChange={(e) => setPassword(e.target.value)}
          value={password}
          className="numeric-input"
        />

        <button disabled={isLoading}>
          {isLoading ? t.loginWait : t.login}
        </button>
        {/* Show loading message below the button */}

        {loadingMessage && <p className="loading-message">{loadingMessage}</p>}

        {error && <div className="error">{error}</div>}
      </form>
    </div>
  );
};

export default Login;
